import { Box } from "@chakra-ui/react";
import { Fragment, type FC } from "react";
import { splitTextForEnquirySearchHighlight } from "../../../utils/textUtils";

type HighlightedSearchTextProps = {
  text?: string;
  query: string;
};

/**
 * Renders `text` with search hits emphasized: suffix/prefix/contiguous substring first,
 * otherwise ordered match (skip extra characters in `text`).
 */
const HighlightedSearchText: FC<HighlightedSearchTextProps> = ({
  text,
  query,
}) => {
  const segments = splitTextForEnquirySearchHighlight(text ?? "", query);
  return (
    <>
      {segments.map((s, i) =>
        s.highlight ? (
          <Box
            as="mark"
            key={i}
            bg="yellow.200"
            display="inline"
            px={0}
            lineHeight="inherit"
          >
            {s.text}
          </Box>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        ),
      )}
    </>
  );
};

export default HighlightedSearchText;
